module.exports = __webpack_public_path__ + "img/logo1.25ac81da.png";